<template>
    <div class="copyright">
        {{ formatCopyright(copyright) }}
        <Markdown
            :source="madeIn"
        />
    </div>
</template>

<script>
import Markdown from 'vue3-markdown-it';

export default {
    name: 'CopyrightText',
    components: {
        Markdown,
    },
    props: {
        copyright: String,
        madeIn: String
    },
    methods: {
        formatCopyright(txt) {
            if (!txt) return

            const now = new Date()
            const YYYY = now.getFullYear()
            return txt.replace('{{YYYY}}', YYYY)
        }
    }
}
</script>

<style
    lang="scss"
>
.copyright {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    min-height: 56px;
    font-size: 12px;
    padding: 12px 4vw;
    text-align: center;
    /* Default: solid black on pages without a video background. */
    background-color: #000;
    color: #fff;

    /* Inline flag icons (Brittany / France) sitting next to the text
       and the ❤️ emoji on the "made in" line. `vertical-align: bottom`
       dropped them below the text baseline so they looked unaligned
       with the heart + words. `middle` centers them on the text line.
       Slightly smaller (18px) reads better next to the 12px copy. */
    img {
        width: 18px;
        vertical-align: middle;
    }

    p {
        margin-top: 0px;
        margin-bottom: 0;
    }
}

/* On the Home view (which has <div class="home">), make copyright
   translucent so the hero video bleeds through. */
body:has(.home) .copyright {
    background-color: rgba(0, 0, 0, 0.4);
}

@media (min-width: 1100px) {
    .copyright {
        padding: 12px 8vw;
    }
}
</style>
